<template>
  <a :href="item.url" class="text-gray-300" @click.prevent>
    <ABadge
      v-if="showTodoBadge"
      dot
      :class="[!item.icon && 'mr-1']"
      :number-style="{ boxShadow: 'none', right: '5px' }">
      <i v-if="item.icon" :class="`common-iconfont-${item.icon}`" class="icon common-iconfont mr-2 text-gray-300" />
    </ABadge>
    <template v-else>
      <i v-if="item.icon" :class="`common-iconfont-${item.icon}`" class="icon common-iconfont mr-2 text-gray-300" />
    </template>
    <span v-show="showMenuTitle">{{ item.name }}</span>
    <ABadge v-if="showUnreadBadge" class="text-sm ml-1" :count="badgeCount" :number-style="{ boxShadow: 'none' }" />

    <ATag v-if="showActivityBadge" class="text-sm ml-2" color="rgb(var(--xs-red-300))">
      {{ $t('menu.focusTips') }}
    </ATag>
  </a>
</template>

<script>
export default {
  name: 'MenuContent',

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showTodoBadge() {
      let { isCollapsed, item } = this

      return item.showBadge || (isCollapsed && item.todoTaskCount)
    },
    showMenuTitle() {
      let { isCollapsed, item } = this

      // 菜单展开或有父菜单时，显示菜单名称
      return !isCollapsed || item.parentMenu.length > 0
    },
    // 未读数量或待办数量
    badgeCount() {
      let { item } = this

      return item.unreadCount || item.todoTaskCount
    },
    showUnreadBadge() {
      // 显示菜单名称的同时且有 badgeCount 数量，才会显示
      return this.showMenuTitle && this.badgeCount
    },
    showActivityBadge() {
      let { isCollapsed, item } = this

      return !isCollapsed && item.activity
    },
  },
}
</script>
